import React, { useEffect, useState } from "react";
import style from "./OutputForm.module.scss";
import { OutputValue } from "./types/types";
import { AppOutputLabel } from "./AppOutputLabel";
import { Provider } from "react-redux";
import store from "../../../../reducks/store/AppTrigger/store";
import { getImageUrl } from "../../../../commons/assets_path";
import { AddOutputModal } from "./AddOutputModal/AddOutputModal";
import useLanguageChange from "../../../../hooks/useLanguageChange";

type Props = {
  output_value: string; // JSON文字列としてのOutputValue配列
  service_icon_name: string;
  template_class_name: string;
  is_display_name_editable: boolean;
  is_test_value_editable: boolean;
  client_id: number;
  workflow_template_id: number;
  selectable_data_type: string; // JSON文字列としてのSelectableDataType配列
  required_add_output_btn: string; // booleanを表す文字列
  test_result?: string;
  test_result_type?: string;
  locale: string;
  output_limit_size: number;
};

export const AppOutputForm = (props: Props) => {
  const { t } = useLanguageChange(props.locale);
  const [outputLabels, setOutputLabels] = useState<OutputValue[]>([]);
  const [addFlg, setAddFlag] = useState<boolean>(false);
  const [isOpenAddOutputModal, setIsOpenAddOutputModal] = useState<boolean>(false);
  const parsedOutputValue = JSON.parse(props.output_value);
  const exceededOutputLimit = outputLabels.filter((item) => !item._destroy).length >= props.output_limit_size;

  useEffect(() => {
    if (props.test_result_type === "file" && parsedOutputValue?.length === 0) {
      setOutputLabels([
        {
          target_id: null,
          display_name: t("AppOutputForm.取得したファイル"),
          test_value: "",
          data_type: "file",
          readonly_test_value: "",
        },
      ]);
    } else {
      setOutputLabels(parsedOutputValue);
    }
  }, []);

  return (
    <div className={style.outputWrap}>
      <div className={style.outputContent}>
        {outputLabels.length !== 0 ? (
          <div id="outputLabels" className={style.outputLabels} style={{ overflow: "scroll", maxHeight: "508px" }}>
            {outputLabels.map((outputLabel, index) => {
              return (
                <Provider store={store} key={index}>
                  <AppOutputLabel
                    outputLabel={outputLabel}
                    setOutputLabels={setOutputLabels}
                    i={index}
                    iconPath={props.service_icon_name}
                    isDisplayNameEditable={props.is_display_name_editable}
                    isTestValueEditable={props.is_test_value_editable}
                    template_class_name={props.template_class_name}
                    length={outputLabels.length}
                    client_id={props.client_id}
                    workflow_template_id={props.workflow_template_id}
                    selectable_data_type={props.selectable_data_type}
                    outputLabels={outputLabels}
                    addFlg={addFlg}
                  />
                </Provider>
              );
            })}
          </div>
        ) : (
          <div id="outputLabels" style={{ height: "30px" }}></div>
        )}
        {props.required_add_output_btn === "true" && (
          <div
            className={`${style.outputAddOutputLabel} js-add_output_fields`}
            style={{ height: "60px" }}
            onClick={() => exceededOutputLimit || setIsOpenAddOutputModal(true)}
          >
            <img src={getImageUrl(exceededOutputLimit ? "images/icons/addGray.svg" : "images/icons/addPrimary.svg")} />
            <div className={`${style.outputAddOutputTitle} ${exceededOutputLimit ? style.disabled : ""}`}>
              {t("AppOutputForm.取得する値を追加")}
            </div>
          </div>
        )}
        <button
          style={{ display: "none" }}
          className="labels"
          type="button"
          onClick={() => {
            setAddFlag(true);
            setOutputLabels([
              ...outputLabels,
              {
                target_id: null,
                display_name: "",
                test_value: "",
                data_type: "text",
                readonly_test_value: "",
              },
            ]);
          }}
        />
        <input id="hiddenApiTestResult" type="hidden" />
      </div>
      <Provider store={store}>
        <AddOutputModal
          isOpen={isOpenAddOutputModal}
          onRequestClose={() => setIsOpenAddOutputModal(false)}
          outputLabels={outputLabels}
          setOutputLabels={setOutputLabels}
          serviceIconName={props.service_icon_name}
          selectableDataType={props.selectable_data_type}
          templateClassName={props.template_class_name}
          output_limit_size={props.output_limit_size}
        />
      </Provider>
    </div>
  );
};
